import MuiCloseIcon from "@mui/icons-material/Close";
import { SvgIconProps, useTheme } from "@mui/material";

export const CloseIcon: React.FC<SvgIconProps> = (props) => {
  const theme = useTheme();

  return (
    <MuiCloseIcon
      {...props}
      sx={{
        color: theme.palette.brandedTypography.textColor,
        ...props.sx,
      }}
    />
  );
};

export default CloseIcon;
